import { fadeIn } from '@/styles';

export const sharedContainerStyles = [fadeIn];
